export default "__VITE_ASSET__f051b55c__"